import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ViewChild,ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { ApiService } from '../api.service';
import { User } from '../database';
import { TranslateService } from '../translate.service';

import { MatDialog,MatDialogConfig} from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild('passwordRecoveryInput') passwordRecoveryInput: ElementRef;

  user: User;
  loginFailed : boolean;
  passwordRecoveryEnabled: boolean;
  passwordRecoveryCompleted: boolean;
  passwordRecoveryUserNotFound: boolean;

  formGroup1: FormGroup;

  constructor(private router: Router, private formBuilder: FormBuilder,elem: ElementRef,private dialog: MatDialog,
              private http: HttpClient, public api:ApiService,public translate: TranslateService) { }

  ngOnInit() {

    this.loginFailed = false;
    this.passwordRecoveryEnabled = false;
    this.passwordRecoveryCompleted = false;
    this.passwordRecoveryUserNotFound = false;

    console.log("LoginComponent.this.api.id_user = " + this.api.id_user);
    console.log("LoginComponent.this.api.id_eventyacht = " + this.api.id_eventyacht);
    // Selezione evento
    this.formGroup1 = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      });
  }

  login(){
    // this.api.login("marco.manuelli@sangiorgiosein.com","12345").subscribe((data:any[]) => {
    this.api.login(this.formGroup1.controls['email'].value,this.formGroup1.controls['password'].value)
    .subscribe((data:any[]) => {

      this.api.authData = data['data'];
      this.api.id_user = this.api.authData.id_user;
      this.api.id_eventyacht = -1;
      this.api.id_event = -1;
      this.api.event_name = "";
      this.api.email = this.formGroup1.controls['email'].value;

      /*
      console.log("login call to api.login returned with : sid=" + this.api.authData.sid);
      console.log("login call to api.login returned with : name=" + this.api.authData.name);
      console.log("login call to api.login returned with : this.api.id_user=" + this.api.id_user);
      console.log("login call to api.login returned with : this.api.email=" + this.api.email);
      */
     
     if (this.api.id_user > 0)
     {
       this.loginFailed = false;
       this.router.navigate(['/events']);
     }
     else
       this.loginFailed = true;
    });
       
  }

  newUser() {
    // Creazione nuovo utente
    this.api.id_user = 0; // Indica alle direttive *ngIf che sto creando nuovo utente
    this.router.navigate(['/user']);
    this.loginFailed = false;  // Elimino eventuali precedenti messaggi di errore login

  }

  passwordRecoveryRequest(){
    // console.log("Test");
    // console.log("password recovery for email : " + this.passwordRecoveryInput.nativeElement.value);

    // Invio email di conferma al nuovo utente registrato e connesso
    const fd = new FormData();
    fd.append('SendPasswordRecoveryMail',this.passwordRecoveryInput.nativeElement.value); // Nota uso @ViewChild !!!!
    this.http.post('api/sendmail.php',fd).subscribe((data: any) => {
        
        if ((data=="KO")||(data=="AUTH_ERROR"))
        {
          this.passwordRecoveryCompleted = false;
          this.passwordRecoveryUserNotFound = true;
        }
        else
        {
          this.passwordRecoveryCompleted = true;
          this.passwordRecoveryUserNotFound = false;
        }

    }); 
  }
 
}
